import storage from 'store'
import expirePlugin from 'store/plugins/expire'
import { login, getInfo, logout } from '@/api/login'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import { welcome } from '@/utils/util'
import { resetRouter } from '@/router'

storage.addPlugin(expirePlugin)
const user = {
  state: {
    token: '',
    name: '',
    welcome: '',
    avatar: '',
    roles: [],
    info: {}
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, { name, welcome }) => {
      state.name = name
      state.welcome = welcome
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_INFO: (state, info) => {
      state.info = info
    },
  },

  actions: {
    // 登录
    Login({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        login(userInfo).then(response => {
          localStorage.setItem('loginInfo',JSON.stringify(response.data));
          const result = response.data
          storage.set(ACCESS_TOKEN, result.token, new Date().getTime() + 7 * 24 * 60 * 60 * 1000)
          commit('SET_TOKEN', result.token)
          localStorage.setItem('simulate',false);
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取用户信息
    GetInfo({ commit }) {
      return new Promise((resolve, reject) => {
        // 请求后端获取用户信息 /api/studentmanage/info
        getInfo().then(async (response) => {
          const { result, role } = response.data
          // 判断职位
          if (result.ps_id) {
            // 超管
            if (result.user_id === 1) {
              commit('SET_ROLES', ['*:*:*'])
              commit('SET_INFO', result)
              commit('SET_NAME', { name: result.user_name, welcome: welcome() })
              commit('SET_AVATAR', '')
              resolve(result)
              return
            }

            commit('SET_ROLES', role)
            commit('SET_INFO', result)
            commit('SET_NAME', { name: result.user_name, welcome: welcome() })
            commit('SET_AVATAR', '')
            // 下游
            resolve(result)
          } else {
            reject(new Error('用户信息错误!'))
          }
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 登出
    Logout({ commit, dispatch, state }) {
      return new Promise((resolve,reject) => {
        logout(state.token).then(async () => {
          commit('SET_TOKEN', '')
          commit('SET_ROLES', [])
          resetRouter();
          storage.remove(ACCESS_TOKEN)
          await dispatch('tagsView/delAllViews')
          resolve()
        }).catch((err) => {
          console.log('logout fail:', err)
          reject(error)
        }).finally(() => {
        })
      })
    }

  }
}

export default user
